import { render } from "./headline.vue?vue&type=template&id=c2fde9dc"
import script from "./headline.vue?vue&type=script&lang=js"
export * from "./headline.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./headline.vue?vue&type=style&index=0&id=c2fde9dc&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/r/Desktop/ev-switch-global/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__